export const COLORS = {
  bgLogin: "#FFF29F",
  bgFloat: "#E6C400",
  bgSystem: "#FFFADB",
  bgRegister: "#FFF29F",
  bgHomeElements: "#FFF5B9",
  bgLoginElements: "#0B8DE9",
  white: "#FFFFFF",
  black: "#000000",
  textPrimary: "#FFFFFF",
  bluePrimary: "#0B8DE9",
} as const;

export const TYPOGRAPHY = {
  // fontFamily: "Roboto, sans-serif",
  // fontSize: "16px",
};

export const SPACING = {
  // small: "8px",
  // medium: "16px",
  // large: "24px",
};